import React from 'react';
import { Box } from '@mui/material';

const shortNameStyles = {
  wrapper: {
    borderRadius: '50%',
    background: (theme) => theme.palette.blues.primaryBlue200,
    color: (theme) => theme.palette.blues.primaryBlue800,
    fontSize: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    padding: '10px',
    fontWeight: 500,
  },
};

export const extendedShortNameStyles = {
  width: '40px',
  minWidth: '40px',
  height: '40px',
};

export const ShortName = ({ children, styles = {}, ...rest }) => (
  <Box sx={{ ...shortNameStyles.wrapper, ...styles }} {...rest}>
    {children}
  </Box>
);

export default ShortName;
